import axios from "axios";

const instance = axios.create({
  baseURL: (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API),
});

export default instance;
